(function () {
  if (customElements.get('ce-accordion') !== undefined) {
    return;
  }

  class Accordion extends HTMLParsedElement {
    constructor() {
      super();

      this.queuedAttributeChangedCallbackParams = [];

      this.selectors = {
        details: '[data-accordion-details]',
        header: '[data-accordion-header]',
        animationTarget: '[data-accordion-animation-target]',
      };

      this.elements = null;

      this.handleClickHeader = this.handleClickHeader.bind(this);
    }

    get isOpen() {
      return this.getAttribute('is-open') === 'true';
    }

    set isOpen(value) {
      this.setAttribute('is-open', value);
    }

    static get observedAttributes() {
      return ['is-open'];
    }

    attributeChangedCallback(...params) {
      if (!this.parsed) {
        this.queuedAttributeChangedCallbackParams.push(params);
        return;
      }

      const [name, oldValue, newValue] = params;

      if (oldValue === newValue) {
        return;
      }

      switch (name) {
        case 'is-open':
          if (newValue !== null) {
            if (newValue === 'true') {
              this.elements.details.setAttribute('open', '');

              const animationTargets = this.querySelectorAll(this.selectors.animationTarget);
              for (let i = 0; i < animationTargets.length; i++) {
                this.playAnimationOpen(animationTargets[i], i);
              }

              this.elements.header.setAttribute('aria-expanded', 'true');
              this.elements.header.setAttribute('aria-pressed', 'true');
            } else {
              this.elements.header.setAttribute('aria-expanded', 'false');
              this.elements.header.setAttribute('aria-pressed', 'false');

              this.elements.details.removeAttribute('open');
            }
          }

          break;
      }
    }

    parsedCallback() {
      this.elements = {
        details: this.querySelector(this.selectors.details),
        header: this.querySelector(this.selectors.header),
      };

      this.elements.header.addEventListener('click', this.handleClickHeader);
    }

    disconnectedCallback() {
      this.elements.header.removeEventListener('click', this.handleClickHeader);
    }

    playAnimationOpen(target, i) {
      const keyframes = [
        { opacity: 0, transform: 'translateY(-16px)' },
        { opacity: 1, transform: 'translateY(0)' },
      ];

      const options = {
        delay: 25 * i,
        duration: Themu.prefersReducedMotion ? 0 : 200,
        easing: Themu.animation.easeIn,
        fill: 'both',
      };

      const animation = target.animate(keyframes, options);
      animation.addEventListener('finish', () => {
        try {
          animation.commitStyles();
        } catch (error) {
          if (error instanceof DOMException) {
            // Fail silently.
          }
        }

        animation.cancel();
      });
    }

    handleClickHeader(event) {
      event.preventDefault();
      this.isOpen = !this.isOpen;
    }
  }

  customElements.define('ce-accordion', Accordion);
})();
